import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-background-950 border-t border-background-800">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-8 mb-10">
          {/* Brand */}
          <div className="lg:col-span-2">
            <div className="flex items-center gap-3 mb-4">
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-primary-500">
                <i className="ri-flask-line text-white text-xl"></i>
              </div>
              <div>
                <div className="font-heading font-700 text-lg text-white tracking-wider uppercase">
                  Poly Alphas Chemicals
                </div>
                <div className="text-accent-400 text-xs font-500 tracking-widest uppercase">C.A.</div>
              </div>
            </div>
            <p className="text-foreground-500 text-sm leading-relaxed max-w-sm mb-4">
              Empresa venezolana líder en la producción y comercialización de químicos
              industriales y fluidos de perforación para la industria petrolera nacional
              e internacional.
            </p>
            <div className="space-y-1.5 mb-5">
              <a href="https://wa.me/584128334239" target="_blank" rel="noopener noreferrer" className="flex items-center gap-2 text-foreground-400 hover:text-green-400 text-sm transition-colors cursor-pointer">
                <i className="ri-whatsapp-line text-green-400"></i>
                +58 412 833 4239
              </a>
              <a href="mailto:ecruz@polyalphas.net" className="flex items-center gap-2 text-foreground-400 hover:text-primary-400 text-sm transition-colors cursor-pointer">
                <i className="ri-mail-line text-primary-400"></i>
                ecruz@polyalphas.net
              </a>
              <div className="flex items-center gap-2 text-foreground-500 text-sm">
                <i className="ri-map-pin-line text-accent-400"></i>
                Venezuela
              </div>
            </div>
            <div className="flex gap-3">
              {[
                { icon: 'ri-instagram-line', href: 'https://www.instagram.com/polyalphas', label: 'Instagram' },
                { icon: 'ri-whatsapp-line', href: 'https://wa.me/584128334239', label: 'WhatsApp' },
                { icon: 'ri-linkedin-box-line', href: '#', label: 'LinkedIn' },
              ].map((s) => (
                <a
                  key={s.label}
                  href={s.href}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  aria-label={s.label}
                  className="w-9 h-9 flex items-center justify-center rounded-lg bg-background-800 text-foreground-400 hover:bg-primary-500 hover:text-white transition-all duration-200 cursor-pointer"
                >
                  <i className={`${s.icon} text-base`}></i>
                </a>
              ))}
            </div>
          </div>

          {/* Links */}
          <div>
            <h5 className="font-heading font-700 text-white text-sm uppercase tracking-wider mb-4">
              Navegación
            </h5>
            <ul className="space-y-2.5">
              {[
                { label: 'Inicio', href: '/' },
                { label: 'Nosotros', href: '/nosotros' },
                { label: 'Productos', href: '/productos' },
                { label: 'Servicios', href: '/servicios' },
                { label: 'Contacto', href: '/contacto' },
              ].map((link) => (
                <li key={link.href}>
                  <Link
                    to={link.href}
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Products */}
          <div>
            <h5 className="font-heading font-700 text-white text-sm uppercase tracking-wider mb-4">
              Productos
            </h5>
            <ul className="space-y-2.5">
              {['PAC-LV', 'PAC-HV', 'Barita API', 'Bentonita API', 'CMC', 'Soda Cáustica'].map((p) => (
                <li key={p}>
                  <Link
                    to="/productos"
                    className="text-foreground-500 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer"
                  >
                    {p}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="border-t border-background-800 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-foreground-600 text-xs text-center sm:text-left">
            &copy; {new Date().getFullYear()} Poly Alphas Chemicals C.A. Todos los derechos reservados.
          </p>
          <p className="text-foreground-700 text-xs">
            Especialistas en Química Industrial &middot; Fluidos de Perforación &middot; Oilfield Chemicals
          </p>
        </div>
      </div>
    </footer>
  );
}